import AdvertiserSelectionSlide from "./AdvertiserSelectionSlide";

export default AdvertiserSelectionSlide;
